/**
 * Generate a unique conversation ID
 */
export function generateConversationId() {
  return `conv_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Format timestamp for display
 */
export function formatTimestamp(timestamp) {
  return new Intl.DateTimeFormat('en-CA', {
    hour: '2-digit',
    minute: '2-digit'
  }).format(timestamp);
}

/**
 * Extract business mentions from text
 */
export function extractBusinessMentions(text, businessList = []) {
  const mentions = [];
  
  businessList.forEach(business => {
    const businessName = business.name.toLowerCase();
    if (text.toLowerCase().includes(businessName)) {
      mentions.push(business);
    }
  });
  
  return mentions;
}

/**
 * Sanitize text input
 */
export function sanitizeInput(text) {
  return text.trim().replace(/[<>]/g, '');
}